import customerLeadForm from './models/customer-lead-form-default-response.json';
import decoder from './models/decoder-default-response.json';
import decoderFordCodes from './models/decoder-ford-codes-default-response.json';
import decoderLincolnCodes from './models/decoder-lincoln-codes-default-response.json';
import government from './models/government-response.json';
import orderStatus from './models/order-status-default-response.json';
import remarketing from './models/remarketing-response.json';
import rental from './models/rental-default-response.json';
import warrantyAssistance from './models/warranty-assistance-default-response.json';
import warrantyInHouse from './models/warranty-in-house-default-response.json';
import warrantyLanding from './models/warranty-landing-default-response.json';

export const PROJECT_SCOPE = 'fpt-fpfc';
export const WARRANTY_LANDING = 'parts-and-service/support/warranty';
export const WARRANTY_LANDING_TO_BE_DEPRECATED =
  'parts-and-service/support/warranty-overview';
export const WARRANTY_IN_HOUSE = `${WARRANTY_LANDING_TO_BE_DEPRECATED}/inhouse-warranty`;
export const WARRANTY_ASSISTANCE = `${WARRANTY_LANDING_TO_BE_DEPRECATED}/assistance-process-form`;
export const WARRANTY_ASSISTANCE_CONFIRMATION = `${WARRANTY_ASSISTANCE}/confirmation`;
export const RENTAL = 'programs/rental';
export const DECODER = 'orders/ordering-production/body-type-decoder';
export const DECODER_FORD_CODES = `${DECODER}/ford-codes`;
export const DECODER_LINCOLN_CODES = `${DECODER}/lincoln-codes`;
export const SECTION_1_MODEL = 'section-1';
export const SECTION_2_MODEL = 'section-2';
export const SECTION_3_MODEL = 'section-3';
export const DISCLOSURE_CONTAINER = 'disclosure-container';
export const ORDER_STATUS = 'orders/order-status';
export const STATUS_MESSAGES = 'status-messages' as const;
export const ORDER_STATUS_STEP2_FORM_DATA_KEY = 'order-status-page-2';
export const REMARKETING = 'programs/remarketing';
export const GOVERNMENT = 'programs/government';
export const CUSTOMER_LEAD_FORM = 'customer-lead-form' as const;
export const FLEET_DIRECTORY = 'resources/ford-pro-directory' as const;
export const DEALER_DIRECTORY = 'resources/dealer-directory' as const;
export const ORDERING_FORM = 'tesla-charging-adapter-form' as const;

export const USER_REGISTRATION = 'get-started';
export const USER_REGISTRATION_ACCESS_CODE = `${USER_REGISTRATION}/access-code`;
export const USER_REGISTRATION_CREATE_PROFILE = `${USER_REGISTRATION}/create-profile`;
export const USER_REGISTRATION_VERIFY = `${USER_REGISTRATION}/verify`;
export const USER_REGISTRATION_THANK_YOU = `${USER_REGISTRATION}/thank-you`;
export const USER_REGISTRATION_STATUS_MESSAGES =
  `${USER_REGISTRATION}/status-messages` as const;
export const USER_REGISTRATION_LOGIN_SUPPORT =
  `${USER_REGISTRATION}/login-support` as const;
export const USER_REGISTRATION_LOGIN_SUPPORT_CONFIRMATION =
  `${USER_REGISTRATION_LOGIN_SUPPORT}/confirmation` as const;

export const ORDER_STATUS_STEP2 = {
  MODEL_YEAR: 'orders/order-status/multiple-vehicles-inquiry',
  DEALER_CODE: 'orders/order-status-item-number',
  PURCHASE_ORDER_NUMBER: 'orders/order-status-purchase-order-number',
  SINGLE_VIN: 'orders/order-status-single-vin',
};

export const ORDER_STATUS_STEP3 =
  'orders/order-status/multiple-vehicles-results';

export const defaultState = {
  [WARRANTY_LANDING]: {
    ...warrantyLanding,
  },
  [WARRANTY_IN_HOUSE]: {
    ...warrantyInHouse,
  },
  [WARRANTY_ASSISTANCE]: {
    ...warrantyAssistance,
  },
  [RENTAL]: {
    ...rental,
  },
  [DECODER]: {
    ...decoder,
  },
  [DECODER_FORD_CODES]: {
    ...decoderFordCodes,
  },
  [DECODER_LINCOLN_CODES]: {
    ...decoderLincolnCodes,
  },
  [ORDER_STATUS]: {
    ...orderStatus,
  },
  [REMARKETING]: {
    ...remarketing,
  },
  [GOVERNMENT]: {
    ...government,
  },
  [CUSTOMER_LEAD_FORM]: {
    ...customerLeadForm,
  },
};

export const DEFAULT_ALL_OPTION = { label: 'All', value: 'All' };
